﻿import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
//import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
//import { first } from 'rxjs/operators';
import {Md5} from 'ts-md5/dist/md5';

//import { AlertService, AuthenticationService } from '../_services';
import { Utils } from '../../providers/utils';
import { ApplicationConstants } from '../../providers/application-constants';
import {TranslateService} from '@ngx-translate/core';
// import { TranslateService } from 'ng2-translate';

// import { InvoiceComponent } from '../invoice/invoice.component';


@Component({templateUrl: 'login.component.html'})
export class LoginComponent implements OnInit {
   // loginForm: FormGroup;
   // loading = false;
    //submitted = false;
   // returnUrl: string;
//private authenticationService: AuthenticationService,
//private alertService: AlertService,
  model = {'user_name': '', 'password': '', 'lang': '', 'as_agent': '0'};
  // model = {'user_name': 'admin', 'password': 'aqeela321', 'lang': ''};
  public compName:string;
  LogIn_Error_Msg;
  has_agent = false;

// private formBuilder: FormBuilder, private route: ActivatedRoute,
    constructor(private router: Router, private utils:Utils, public applicationConstants:ApplicationConstants, 
      public translate: TranslateService) {

       if(!applicationConstants.isinit) 
        this.router.navigate(['']);

      this.model['lang'] = this.applicationConstants.user_lang;
      applicationConstants.system_expiry_date = utils.getParamValue('system_expiry_date');
      
      this.getMessages(translate);
    }

    getMessages(translate) {
      this.compName = this.utils.getParamValue('company_name_' + this.applicationConstants.user_lang);

      translate.setDefaultLang(this.applicationConstants.user_lang);
      translate.use(this.applicationConstants.user_lang);

      translate.get('LogIn_Error_Msg').subscribe((res: string) => {
        this.LogIn_Error_Msg = res;
      });
    }

    ngOnInit() {
        this.has_agent = (this.utils.getParamValue('has_agent') == '1');
        (document.getElementById('user_name') as HTMLInputElement).focus();
        this.applicationConstants.isLogged = false;
        // this.login();

        // this.loginForm = new FormGroup({
        //     username: new FormControl(['', Validators.required]),
        //     password: new FormControl(['', Validators.required])
        // });

        // reset login status
        //this.authenticationService.logout();
        
        //console.log('1');

        // get return url from route parameters or default to '/'
        //this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
        //console.log(this.returnUrl);
    }

    changeLang() {
      this.applicationConstants.user_lang = this.model['lang'];
      this.getMessages(this.translate); 
    }

    changeAsAgent() {
      this.model['as_agent'] = ((document.getElementById('as_agent') as HTMLInputElement).checked ? '1' : '0');
    }

    // ngOnChanges()
    // {
    //     this.applicationConstants.isLogged = false;
    // }

    // convenience getter for easy access to form fields
    //get f() { return this.loginForm.controls; }

    login() {
        //this.submitted = true;

        // stop here if form is invalid
        // if (this.loginForm.invalid) {
        //     return;
        // }
        this.applicationConstants.main_menu = [];
        this.applicationConstants.sub_menu_all = [];
        let password = String(Md5.hashStr(this.model['password']));
        let query, obj, query2, obj2;

        if (this.model['as_agent'] == '0') {

          query = "SELECT `user`.*, `employee`.`name`, `employee`.`name_en` FROM `user`, `employee` WHERE `user`.`user_name` = '" + 
            this.model.user_name + "' AND `user`.`user_password` = '" + password + "' and `user`.`status` = '1' AND " + 
            " `user`.`employee_no` = `employee`.`employee_no`";
          //console.log(query);
          obj = {cmd: 'getList', query:query};

          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();

              if(data.data['list'].length == 1)
              { 
                this.applicationConstants.user_info = data.data['list'][0];
                this.applicationConstants.user_info['casher_acct_number'] = data.data['list'][0]['acct_number'];
                this.applicationConstants.user_info['company_id'] = "1";// TEMP

                this.applicationConstants.isLogged = true;

                // check expiry date
                let diff_days = 100;
                if (this.applicationConstants.system_expiry_date != '' && this.applicationConstants.system_expiry_date != 'NPV') {
                  let expiry_date = new Date(this.applicationConstants.system_expiry_date);
                  let today = new Date();
                  
                  if (today > expiry_date)
                    diff_days = -1;
                  else {
                    let diff = Math.abs(expiry_date.getTime() - today.getTime());
                    diff_days = Math.ceil(diff / (1000 * 3600 * 24)); 
                  }

                  this.applicationConstants.system_expired = (diff_days <= 0);
                  this.applicationConstants.system_will_expire = (diff_days <= 31 && diff_days > 0);
                }

                if (diff_days > 0) {

                  query2 = "SELECT `user_auth`.*, `menu_item`.*, `menu`.menu_name_ar, `menu`.menu_name_en, `menu`.seq, `menu`.display, `menu`.`menu_icon`"
                            +" FROM `user_auth`, `menu_item`, `menu` WHERE `user_auth`.`user_id` = '" + this.applicationConstants.user_info['user_id']
                            + "' AND `user_auth`.`status` ='1' AND `user_auth`.`menu_item_id` = `menu_item`.`menu_item_id` AND `menu_item`.`menu_id` = `menu`.`menu_id` AND `menu_item`.`display` = 'T' "
                            + " AND (`user_auth`.`view_auth` = '1' OR `user_auth`.`add_auth` = '1' OR `user_auth`.`edit_auth` = '1' OR`user_auth`.`delete_auth` = '1' ) ORDER BY `menu`.`seq`, `menu_item`.`seq`";
                  obj2 = { cmd: 'getList', query: query2 };

                  this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
                    .subscribe(data => {
                      this.applicationConstants.appComp.hideBusyCursor();

                      this.applicationConstants.user_info['authList'] = data.data['list'];
                      this.applicationConstants.sub_menu_all = this.applicationConstants.user_info['authList'];
                      // here we need to generate the menu and submenues based on authorization 
                      // this.applicationConstants.sub_menu_all.forEach(mi => {

                      // });

                      this.applicationConstants.main_menu = [];
                      // const main_menu = [];
                      const map = new Map();
                      let file_path = '';
                      let route_path = '';
                      let pathC = '';
                      let class_name = '';
                      let re = /\_/gi;

                      for (const mi of this.applicationConstants.sub_menu_all) {
                        // console.log("mi: ");
                        // console.log(map.has(mi.menu_id));

                        if(!map.has(mi.menu_id)) {
                            map.set(mi.menu_id, true);    // set any value to Map

                            mi.showSubmenu = false;
                            mi.children = [];
                            mi.children.push(mi);
                            // main_menu.push(mi);
                            // mi.icon = this.applicationConstants.appFolder + '/assets/image/' + mi.menu_icon;
                            this.applicationConstants.main_menu.push(mi);
                        }
                        else 
                          this.applicationConstants.main_menu[this.applicationConstants.main_menu.length - 1].children.push(mi);

                          // generate dynamic routing                        
                        route_path = 'sub_menu/';
                        route_path += mi.menu_id + '/' + mi.route; 
                        pathC = mi.route.replace(re, "-");
                        file_path = '../' + pathC + '/' + pathC + '.component';
                        class_name = this.utils.snakeToCamel(mi.route);

                        //console.log(class_name); 
                        class_name = class_name.charAt(0).toUpperCase() + class_name.slice(1);
                        //console.log(class_name);
                        class_name += 'Component';
                        // console.log(route_path);
                        // console.log(file_path);
                        // console.log(class_name);
                        const dynModule = require('../' + pathC + '/' + pathC + '.component'); // '../invoice/invoice.component');
                        const klass = dynModule[class_name]; //"InvoiceComponent"];
                          //let instance: any = new klass(); 
                          //instance.constructor.apply(instance);
                          //this.router.config.unshift({ path: route_path, component: instance});
                      }

                      // console.log("main_menu: ");
                      // console.log(this.applicationConstants.main_menu);

                      //console.log(this.router);
                      //console.log(main_menu);
                      
                      //let main_menu = data.data['list'];
                      // let index = 0;
                      // let col_num = 3;
                      // let row_obj;

                      // let menu_len = main_menu.length;
                      // if(menu_len == 4)
                      //   col_num = 2;
                      // else if(menu_len > 6 && menu_len <= 8) // make number of item in row = 4
                      //   col_num = 4;
                      // else if(menu_len > 8  && menu_len <= 10)
                      //   col_num = 5;
                      // else if(menu_len > 10)
                      //   col_num = 6;
                      
                      // main_menu.forEach(element => {
                      //   if(index % col_num == 0) {
                      //     row_obj = {'row_index':this.applicationConstants.main_menu.length, 'col_list':[]};
                      //     this.applicationConstants.main_menu.push(row_obj);
                      //   } 
                      //   row_obj.col_list.push(element);
                      //   index++;
                      // });

                      // console.log(this.applicationConstants.main_menu);
                      //this.applicationConstants.main_menu = result;

                      query = "SELECT * FROM `business_cycle` WHERE `is_active` = '1' AND `status` = '1'";
                      obj = {cmd: 'getList', query:query};
              
                      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                        .subscribe(data => {
                          this.applicationConstants.appComp.hideBusyCursor();
                          if (data.data['list'].length > 0)
                            this.applicationConstants.business_cycle = data.data['list'][0];
                        });

                      this.router.navigate(['/user_main']);
                    });
                }
                else 
                  this.router.navigate(['/user_main']);
                  //public user_info = { company_id:'1', branch_id:'1', casher_acct_number:'101001', user_name:'admin', user_full_name:'المشرف العام' };
                  //console.log(data.data['list'][0]);
                  
                  //console.log(this.applicationConstants.user_info);
                  //this.router.navigate(['/user_main']);
                  
                  //let query2 = "SELECT `user_auth`.*, `menu_item`.* FROM `user_auth`, `menu_item`, `menu` WHERE `user_auth`.`user_id` = '" + this.applicationConstants.user_info['user_id']
                    //+ "' AND `user_auth`.`status` ='1' AND `user_auth`.`menu_item_id` = `menu_item`.`menu_item_id` AND `menu_item`.`menu_id` = `menu`.`menu_id` ORDER BY `menu`.`seq`, `menu_item`.`seq`";
                  
              }
              else {
                this.model['password'] = '';
                document.getElementById("password").focus();
                alert(this.LogIn_Error_Msg);
              } 
          });
        }
        else {
          // log in as agent
          query = "SELECT `customer`.*, (CASE WHEN `customer`.`branch_id` = '0' THEN (SELECT `branch`.`branch_id` FROM `branch` LIMIT 1)" + 
            " ELSE `customer`.`branch_id` END) AS 'agent_branch_id', (CASE WHEN `customer`.`branch_id` = '0' THEN (SELECT `branch`.`branch_name` FROM `branch` LIMIT 1)" + 
            " ELSE (SELECT `branch`.`branch_name` FROM `branch` WHERE `customer`.`branch_id` = `branch`.`branch_id`) END) AS 'branch_name'," + 
            " (CASE WHEN `customer`.`branch_id` = '0' THEN (SELECT `branch`.`branch_name_en` FROM `branch` LIMIT 1)" + 
            " ELSE (SELECT `branch`.`branch_name_en` FROM `branch` WHERE `customer`.`branch_id` = `branch`.`branch_id`) END) AS" + 
            " 'branch_name_en' FROM `customer` WHERE `customer`.`user_name` = '" + this.model.user_name + 
            "' AND `customer`.`user_password` = '" + password + "' AND `customer`.`status` = '1'";
          
          obj = {cmd: 'getList', query:query};
          this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
            .subscribe(data => {
              this.applicationConstants.appComp.hideBusyCursor();
              
              if(data.data['list'].length == 1)
              { 
                this.applicationConstants.user_info = data.data['list'][0];
                this.applicationConstants.user_info['casher_acct_number'] = data.data['list'][0]['acct_number'];
                this.applicationConstants.user_info['company_id'] = "1"; // TEMP

                this.applicationConstants.user_branch_info.user_branch_id = data.data['list']['0']['agent_branch_id'];
                this.applicationConstants.user_branch_info.user_branch_name = data.data['list']['0']['branch_name'];
                this.applicationConstants.user_branch_info.user_branch_name_en = data.data['list']['0']['branch_name_en'];
                this.applicationConstants.isLogged = true;

                // check expiry date
                let diff_days = 100;
                if (this.applicationConstants.system_expiry_date != '' && this.applicationConstants.system_expiry_date != 'NPV') {
                  let expiry_date = new Date(this.applicationConstants.system_expiry_date);
                  let today = new Date();
                  
                  if (today > expiry_date)
                    diff_days = -1;
                  else {
                    let diff = Math.abs(expiry_date.getTime() - today.getTime());
                    diff_days = Math.ceil(diff / (1000 * 3600 * 24)); 
                  }

                  this.applicationConstants.system_expired = (diff_days <= 0);
                  this.applicationConstants.system_will_expire = (diff_days <= 31 && diff_days > 0);
                }

                if (diff_days > 0) {

                  query2 = "SELECT `menu_item`.*, `menu`.menu_name_ar, `menu`.menu_name_en, `menu`.seq, `menu`.display, `menu`.`menu_icon`" + 
                    " FROM `menu_item`, `menu` WHERE (`menu_item`.`menu_item_id` = '91' OR `menu_item`.`menu_item_id` = '97' OR `menu_item`.`menu_item_id` = '119')" + 
                    " AND `menu_item`.`menu_id` = `menu`.`menu_id` AND `menu_item`.`display` = 'T' ORDER BY `menu`.`seq`, `menu_item`.`seq`";
                  obj2 = { cmd: 'getList', query: query2 };

                  this.utils.invokeHttp(this.applicationConstants.generalFile, obj2)
                    .subscribe(data => {
                      this.applicationConstants.appComp.hideBusyCursor();

                      this.applicationConstants.user_info['authList'] = data.data['list'];
                      this.applicationConstants.sub_menu_all = this.applicationConstants.user_info['authList'];

                      this.applicationConstants.main_menu = [];
                      // const main_menu = [];
                      const map = new Map();
                      let file_path = '';
                      let route_path = '';
                      let pathC = '';
                      let class_name = '';
                      let re = /\_/gi;

                      for (const mi of this.applicationConstants.sub_menu_all) {
                        // console.log("mi: ");
                        // console.log(map.has(mi.menu_id));

                        if(!map.has(mi.menu_id)) {
                            map.set(mi.menu_id, true);    // set any value to Map

                            mi.showSubmenu = false;
                            mi.children = [];
                            mi.children.push(mi);
                            // main_menu.push(mi);
                            // mi.icon = this.applicationConstants.appFolder + '/assets/image/' + mi.menu_icon;
                            this.applicationConstants.main_menu.push(mi);
                        }
                        else 
                          this.applicationConstants.main_menu[this.applicationConstants.main_menu.length - 1].children.push(mi);

                          // generate dynamic routing                        
                        route_path = 'sub_menu/';
                        route_path += mi.menu_id + '/' + mi.route; 
                        pathC = mi.route.replace(re, "-");
                        file_path = '../' + pathC + '/' + pathC + '.component';
                        class_name = this.utils.snakeToCamel(mi.route);

                        //console.log(class_name); 
                        class_name = class_name.charAt(0).toUpperCase() + class_name.slice(1);
                        //console.log(class_name);
                        class_name += 'Component';
                        // console.log(route_path);
                        // console.log(file_path);
                        // console.log(class_name);
                        const dynModule = require('../' + pathC + '/' + pathC + '.component'); // '../invoice/invoice.component');
                        const klass = dynModule[class_name]; //"InvoiceComponent"];
                          //let instance: any = new klass(); 
                          //instance.constructor.apply(instance);
                          //this.router.config.unshift({ path: route_path, component: instance});
                      }

                      query = "SELECT * FROM `business_cycle` WHERE `is_active` = '1' AND `status` = '1'";
                      obj = {cmd: 'getList', query:query};
              
                      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                        .subscribe(data => {
                          this.applicationConstants.appComp.hideBusyCursor();
                          if (data.data['list'].length > 0)
                            this.applicationConstants.business_cycle = data.data['list'][0];
                        });

                      this.router.navigate(['/user_main']);
                    });
                }
                else 
                  this.router.navigate(['/user_main']);
              }
              else {
                this.model['password'] = '';
                document.getElementById("password").focus();
                alert(this.LogIn_Error_Msg);
              } 
            });
        }
    }
}
